import React from 'react';
import { useTranslation } from 'react-i18next';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { FormField } from '../../redux/types';
import LabelledToggleField from '../base/LabelledToggleField';
import s from './EarlyAccessToggle.scss';

interface Props {}

const EarlyAccessToggle: React.FC<Props> = () => {
  const { t } = useTranslation();
  return (
    <LabelledToggleField
      name={FormField.EarlyAccess}
      size="small"
      label={t('sellerModal.create.early_access.label')}
      subLabel={t('sellerModal.create.early_access.sublabel', {
        postProcess: ['reactPostprocessor', 'featureBrancher'],
        learnMoreLink: (
          <PlainButtonOrLink
            className={s['link']}
            href={t('sellerModal.create.early_access.sublabel.link.url')}
          >
            {t('sellerModal.create.early_access.sublabel.link.text')}
          </PlainButtonOrLink>
        ),
      })}
      onChange={() => {}}
    />
  );
};

EarlyAccessToggle.displayName = 'EarlyAccessToggle';

export default EarlyAccessToggle;
